<div class="container">
  <nav class="mixed-loyalty-nav d-flex flex-row align-items-center">
    <a
      class="nav-item"
      [routerLink]="['/rewards/marketplace']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'mixed.nav.marketplace' | translate }}</label>
    </a>

    <a
      class="nav-item"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'mixed.nav.raffles' | translate }}</label>
    </a>

    <a
      class="nav-item"
      [routerLink]="['/rewards/events']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'mixed.nav.events' | translate }}</label>
    </a>

    <a
      class="nav-item d-lg-flex d-none"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'rewards.nav.wallet' | translate }}</label>
    </a>
  </nav>
</div>
